import { ConnectionPositionPair } from '@angular/cdk/overlay';
import { ChangeDetectionStrategy, Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { MenuTriggerForDirective } from '@vsolv/vectors-ui/menu';
import { DescriptiveColumnConfig, getAllColumnConfigs, getColumnConfig } from './descriptive-columns.config';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'ws-new-descriptive-columns-button',
  templateUrl: './new-descriptive-columns-button.component.html',
  standalone: false,
})
export class NewDescriptiveColumnsButtonComponent {
  @ViewChild('trigger') trigger?: MenuTriggerForDirective;

  @Output() addedColumns = new EventEmitter<string[]>();

  selectedColumns: string[] = [];
  availableColumns: DescriptiveColumnConfig[] = getAllColumnConfigs();

  positions = [new ConnectionPositionPair({ originX: 'end', originY: 'bottom' }, { overlayX: 'end', overlayY: 'top' })];

  getColumnName(columnKey: string): string {
    const config = getColumnConfig(columnKey);
    return config?.label || columnKey;
  }

  getColumnDescription(columnKey: string): string {
    const config = getColumnConfig(columnKey);
    return config?.description || '';
  }

  toggleColumn(columnKey: string) {
    if (this.selectedColumns.includes(columnKey)) {
      this.selectedColumns = this.selectedColumns.filter(c => c !== columnKey);
    } else {
      this.selectedColumns.push(columnKey);
    }
  }

  addColumns() {
    this.addedColumns.emit([...this.selectedColumns]);
    this.close();
  }

  close() {
    this.selectedColumns = [];
    this.trigger?.close();
  }
}
